import type {
  CompareToolContentItemsProps,
  compareItemsInterface,
  filterType
} from "./interface";

export const getPairedFilterItemsByLabel = (
  itemsToCompare: compareItemsInterface
): CompareToolContentItemsProps[] =>
  itemsToCompare.from?.value.data?.map(item => {
    const pairedItem = itemsToCompare.to?.value.data?.find(
      toItem => toItem.label === item.label
    );
    return {
      label: item.label,
      from: item.value,
      to: pairedItem?.value
    };
  }) || [];

export const filterItems = (
  filter: filterType,
  searchText: string,
  item: CompareToolContentItemsProps
): boolean => {
  if (
    searchText !== "" &&
    !item?.label?.toLowerCase()?.includes(searchText?.toLowerCase())
  ) {
    return false;
  }
  if (!filter || filter === "All") {
    return true;
  }
  return (
    (filter === "similar" && item.from === item.to) ||
    (filter === "different" && item.from !== item.to)
  );
};
